import { UnitsManagementConst } from '@featureModule/units-management/consts';

/**
 * Local alias for the Units child const to keep mapper expressions concise.
 */
const UNITS_CONST = UnitsManagementConst.CHILDREN.UNITS;

/**
 * Translate key mapper for the Units view component.
 * All keys are functions so they re-evaluate after a language switch.
 */
export const UnitsTranslateMapper = {

    /** Page title. */
    TITLE: () => `${UNITS_CONST.TRANSLATE_KEY()}.TITLE`,

    /** Sidebar menu label. */
    MENU_LABEL: () => `${UNITS_CONST.TRANSLATE_KEY()}.MENU_LABEL`,

    /** Card header actions. */
    GENERAL: {
        ADD_ROOT_UNIT: () => `${UNITS_CONST.TRANSLATE_KEY()}.GENERAL.ADD_ROOT_UNIT`,
        RELOAD:        () => `${UNITS_CONST.TRANSLATE_KEY()}.GENERAL.RELOAD`,
    },

    /** Details panel section. */
    DETAILS: {
        NAME:        () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.NAME`,
        DESCRIPTION: () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.DESCRIPTION`,
        TYPE:        () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.TYPE`,
        LEVEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.LEVEL`,
        CREATED_ON:  () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.CREATED_ON`,
        LATITUDE:    () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.LATITUDE`,
        LONGITUDE:   () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.LONGITUDE`,
        X_COORD:     () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.X_COORD`,
        Y_COORD:     () => `${UNITS_CONST.TRANSLATE_KEY()}.DETAILS.Y_COORD`,
    },

    /** Add/edit form. */
    FORM: {

        ADD_UNIT:    () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.ADD_UNIT`,
        EDIT_UNIT:   () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.EDIT_UNIT`,
        DELETE_UNIT: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.DELETE_UNIT`,
        DELETE_CONFIRM: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.DELETE_CONFIRM`,

        NAME: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.NAME.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.NAME.PLACEHOLDER`,
        },

        DESCRIPTION: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.DESCRIPTION.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.DESCRIPTION.PLACEHOLDER`,
        },

        COLOR: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.COLOR.LABEL`,
        },

        TYPE: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.TYPE.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.TYPE.PLACEHOLDER`,
        },

        PARENT: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.PARENT.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.PARENT.PLACEHOLDER`,
        },

        LEVEL: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.LEVEL.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.LEVEL.PLACEHOLDER`,
        },

        ICON: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.ICON.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.ICON.PLACEHOLDER`,
        },

        LATITUDE: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.LATITUDE.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.LATITUDE.PLACEHOLDER`,
        },

        LONGITUDE: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.LONGITUDE.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.LONGITUDE.PLACEHOLDER`,
        },

        X_COORD: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.X_COORD.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.X_COORD.PLACEHOLDER`,
        },

        Y_COORD: {
            LABEL:       () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.Y_COORD.LABEL`,
            PLACEHOLDER: () => `${UNITS_CONST.TRANSLATE_KEY()}.FORM.Y_COORD.PLACEHOLDER`,
        },

    },

};
